export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const APPEARANCES = {
  accent: 'accent',
  primary: 'primary',
  warning: 'warning',
};

export const POSITION = {
  default: 'default',
  top: 'top',
  bottom: 'bottom',
};
